import {SessionStorageCache} from "../../SessionStorageCache";
import {confluenceService} from "../../api/ConfluenceService";

const CACHE_KEY_PREFIX = "userClickedMenuActivity-";

interface UserActivity {
    accountId: string,
    clickedMenuCount: number,
}

class MenuActivityController extends SessionStorageCache {

    async incrementClickedMenuActivity() {
        const contextData = confluenceService.getCurrentUserAndHost();
        const cachedActivity = await this.loadFromCache(contextData.accountId, contextData.clientKey);
        const newCount = cachedActivity ? cachedActivity.clickedMenuCount + 1 : 1;
        this.updateCache(contextData.clientKey, this.buildCacheItem(newCount, contextData.accountId));
        return newCount;
    }

    async updateCache(hostInfo: string, activity: UserActivity) {
        this.setItem(this.buildCacheKey(hostInfo), activity);
    }

    private buildCacheItem = (clickedMenuCount: number, accountId: string): UserActivity => {
        return {
            accountId,
            clickedMenuCount
        };
    }

    async loadFromCache(accountId: string, hostInfo: string) {
        const cachedActivity = this.getItem(this.buildCacheKey(hostInfo)) as UserActivity;
        if (cachedActivity?.accountId !== accountId) {
            return undefined;
        }

        return cachedActivity;
    }

    private buildCacheKey = (hostInfo: string) => {
        return CACHE_KEY_PREFIX + hostInfo;
    }
}

export const menuActivityController = new MenuActivityController();
